import { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { applyNormalRichTextStyle } from '../../utils/richText';
import '../../css/richText/richText.css';

function handleNormalStyle() {
    applyNormalRichTextStyle(this.quill);
}

/** One toolbar for articles, folders, pedagogical content, and machine sections. */
export const RICH_TEXT_MODULES = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline'],
            [{ header: 1 }, { header: 2 }, { header: 3 }, 'normal'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }],
        ],
        handlers: {
            normal: handleNormalStyle,
        },
    },
};

export const RICH_TEXT_FORMATS = ['bold', 'italic', 'underline', 'header', 'list', 'color', 'background'];

/**
 * Shared rich-text field. Limits are the toolbar (props), not a second editor.
 */
const RichTextEditor = ({ value, onChange, placeholder }) => {
    const rootRef = useRef(null);

    useEffect(() => {
        const buttons = rootRef.current?.querySelectorAll('.ql-toolbar button');
        buttons?.forEach((button) => {
            if (!button.getAttribute('type')) {
                button.setAttribute('type', 'button');
            }
        });
        const normalButton = rootRef.current?.querySelector('button.ql-normal');
        if (normalButton) {
            normalButton.setAttribute('aria-label', 'Style normal');
            normalButton.setAttribute('title', 'Style normal');
        }
    }, []);

    return (
        <div ref={rootRef} className="richTextEditor">
            <ReactQuill
                theme="snow"
                modules={RICH_TEXT_MODULES}
                formats={RICH_TEXT_FORMATS}
                value={value || ''}
                onChange={(html, _delta, source) => {
                    if (source === 'user') {
                        onChange(html);
                    }
                }}
                placeholder={placeholder}
            />
        </div>
    );
};

export default RichTextEditor;
